import { post } from "../axios";

export default {
  // 揽客

  memberCardList() {
    return post("member/card/memberCardList");
  },
  // 获取揽客券列表
  getShareCouponsList() {
    return post("member/coupon/getShareCouponsList");
  },
  // 获取揽客详情
  getCouponDetail({id}) {
    return post("member/coupon/getCouponDetail",{id});
  },
  // 领取揽客券
  getCoupon({id}) {
    return post("member/coupon/getCoupon",{id});
  },



  // 门店详情
  getStoreDetail({sid}) {
    return post("member/Rescue/getStoreDetail", {sid});
  },
  // 获取详情图
  getStoreContent({sid}) {
    return post("member/Rescue/getStoreContent", {sid});
  },
  // 获取关注头像
  getStoreFocusList() {
    return post("/member/Rescue/getStoreFocusList");
  },
  // 获取关注头像
  setEvaluationNum({id}) {
    return post("/member/Rescue/setEvaluationNum",{id});
  },
};



// WEBPACK FOOTER //
// ./src/Interface/api/marketing.js